import ReCAPTCHA from "react-google-recaptcha";
import {useAuth, useDarkMode} from "../../context";
import {config, endpoints} from "../../utils2";
import {useGetJsonDirect} from "../../hooks";
import {Alert} from "react-bootstrap";
import React from "react";


export function CustomRecaptcha({onChange}) {
    const {darkMode} = useDarkMode()
    const {authToken} = useAuth()

    const {value: recaptcha, error: recaptchaError, clearError: clearRecaptchaError} = useGetJsonDirect(endpoints.contact.recaptcha(), authToken?.jwt)

    return <>
        <Alert variant="danger" show={recaptchaError} dismissible onClose={clearRecaptchaError}>{recaptchaError}</Alert>
        {recaptcha && <ReCAPTCHA
        key={darkMode ? "dark" : "light"}
        sitekey={recaptcha.site_key}
        size="normal"
        theme={darkMode ? "dark" : "light"}
        onChange={onChange}
    />}
    </>
}
